import { AddFeedbackComponent } from './add-feedback/add-feedback.component';
import { FeedbackComponent } from './feedback.component';
import { ViewFeedbackComponent } from './view-feedback/view-feedback.component';

export const FeedBackDeclaration = [
    FeedbackComponent,
    AddFeedbackComponent,
    ViewFeedbackComponent
];
